module.exports = __webpack_public_path__ + "static/media/Successful.65df2e61.png";